<template>
    <div>
        <multiselect class="form-control" v-model="modelo.idgrado" :options="datos" track-by="id" label="nombre" 
        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Seleccione..."></multiselect>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ model:Object,default:{type:Object,required:false,default:null} },
    data(){
        return{
            datos: [],
            modelo: {
                idgrado: null, 
            }
        }
    },
    watch:{
        'modelo.idgrado': function(){this.model.idgrado=this.modelo.idgrado; },
        'default': function(){
            if( this.default.nivel ){
                this.modelo.idgrado = this.datos.find( x => x.nivel == this.default.nivel );
            }
        }
    },
    methods:{
        async getDatos() {
            var vue = this;
            var sql = gql`query{getGrados{id,nombre,nivel}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                vue.datos = data.data.getGrados; 
                if( this.default ){
                    this.modelo.idgrado = vue.datos.find( x => x.nivel == this.default.nivel );
                }
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getGrados' ) )
            })
        },
    },
    mounted(){
        this.getDatos();
    }
}
</script>